import { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { axiosAuth, decodeToken, errorHandling, axiosTte,axiosDisposisi } from "../../helpers"
import { loginData, logout } from "../../stores/auth"
import swal from "sweetalert"
import { useNavigate } from "react-router-dom"
import { changeTokenApp,updateAccountToken } from '../../stores/auth'

const useProfile = () => {

    const navigate = useNavigate()
    const dispatch = useDispatch()
    const [data, setData] = useState()
    const [formData, setFormData] = useState({
        nik: ""
    })
    const [formDataSatker, setFormDataSatker] = useState({
        kode_satker_utama: ""
    })
    const [isAdmin, setIsAdmin] = useState(false)
    const [isLoading, setIsLoading] = useState(true)
    const [isUpdateNik, setIsUpdateNik] = useState(false)
    const [isUpdateSatker, setIsUpdateSatker] = useState(false)
    const [isEdit, setIsEdit] = useState(false)
    const [isEditSatker, setIsEditSatker] = useState(false)
    const [isSync, setIsSync] = useState(false)
    const dataLogin = useSelector(loginData)

    const [allSatker, setAllSatker] = useState([])
    const [allSatkerOptions, setAllSatkerOptions] = useState([])
    const getAllSatker = async (keyword = '') => {
        try {
            // setIsLoading(true)

            const response = await axiosAuth.get('/v1/satker', {
                params: {
                    keyword: keyword || undefined,
                },
                headers: {
                    Authorization: `Bearer ${dataLogin.token_account}`,
                },
            })

            if (response.data.status_code === 200) {
                const reformattedArray = response.data.data.rows.map(
                    ({ satuan_kerja, kode_satuan_kerja }) => ({
                        value: kode_satuan_kerja,
                        label: satuan_kerja,
                    })
                )

                setAllSatkerOptions(reformattedArray)
            } else {
                swal(
                    'Terjadi Kesalahan',
                    'Silakan coba beberapa saat lagi atau hubungi developer',
                    'error'
                )
            }
        } catch (error) {
            console.error(error)
        } finally {
            // setIsLoading(false)
        }
    }

    // const getAllSatker = async () => {

    //     try {

    //         setIsLoading(true)
    //         const response = await axiosAuth.get(`/v1/satker`, {
    //             headers: {
    //                 'Authorization': `Bearer ${dataLogin.token_account}`,
    //             }
    //         });

    //         if (response.data.status_code === 200) {
    //             setAllSatker(response.data.data.rows)
    //             const kvArray = [
    //                 { key: 1, value: 10 },
    //                 { key: 2, value: 20 },
    //                 { key: 3, value: 30 },
    //             ];

    //             const reformattedArray = response.data.data.rows.map(({ satuan_kerja, kode_satuan_kerja }) => ({ value: kode_satuan_kerja, label: satuan_kerja }));
    //             setAllSatkerOptions(reformattedArray)
    //         } else {
    //             swal('Terjadi Kesalahan', "Silakan coba beberapa saat lagi atau hubungi developer", 'error')
    //         }
    //         // const response = await axios.get(
    //         //     `/v1/satker`,
    //         //     {
    //         //         params: {
    //         //             // start_time: dateConvertion(startStr, "toTimestamp"),
    //         //             // end_time: dateConvertion(endStr, "toTimestamp"),
    //         //         },
    //         //         headers: {
    //         //             'Authorization': `Bearer ${dataLogin.token_account}`,
    //         //         }
    //         //     }
    //         // )

    //         // if (response.data.status_code === 200) {
    //         //     var evs = response.data.data.map((e) => ({
    //         //         ...e,
    //         //         // value: e.
    //         //         // title: e.nama,
    //         //         // topic: e.topik,
    //         //         // start: dateConvertion(e.waktu_mulai, "toFormatDateTime"),
    //         //         // end: dateConvertion(e.waktu_selesai, "toFormatDateTime")
    //         //     }))
    //         //     console.log(evs);
    //         //     setAllSatker(evs)
    //         // }
    //     } catch (_) { }
    // }
    // const kode_satker_utama = decodeToken(dataLogin.token_account)['kode_satker_utama'];
    // let mSatkerFind = allSatker.find(satker => satker.kode_satuan_kerja === kode_satker_utama)
    useEffect(() => {
        // const fetchData = async () => {
        // await getAllSatker()
        // await getProfileData()
        // setIsAdmin(decodeToken(dataLogin.token_account)['is_admin'])
        // }

        // fetchData()

        getAllSatker()
        getProfileData()
        setIsAdmin(decodeToken(dataLogin.token_account)['is_admin'])
    }, [])
    const [selectedValue, setSelectedValue] = useState(null); // Initial state, no selection

    const mHandleChange = (selectedOption) => {
        setSelectedValue(selectedOption);
    };
    const getProfileData = async () => {
        try {
            setIsLoading(true)
            const response = await axiosAuth.get(`/v1/profile`, {
                headers: {
                    'Authorization': `Bearer ${dataLogin.token_account}`,
                }
            });

            if (response.data.status_code === 200) {
                setData(response.data.data)

                const nip = decodeToken(dataLogin.token_account)['nip'];
                // let mSatkerFind = allSatker.find(satker => satker.kode_satuan_kerja === data.kode_satker_utama)
                // if (mSatkerFind && mSatkerFind?.kode_satuan_kerja) {

                let selectedOptionDari =
                    { value: response.data.data.kode_satker_utama, label: response.data.data.satker_utama }
                setFormDataSatker({ ...formDataSatker, nip: nip, kode_satker_utama: selectedOptionDari })
                console.log(selectedOptionDari)
                // }

                // setFormDataSatker({ ...formDataSatker, nip: nip, kode_satker_utama: response.data.data.kode_satker_utama })
                // console.log(response.data.data.kode_satker_utama)
                // setSelectedValue(response.data.data.kode_satker_utama)
            } else {
                swal('Terjadi Kesalahan', "Silakan coba beberapa saat lagi atau hubungi developer", 'error')
            }
        } catch (err) {
            swal('Error', errorHandling(err), 'error')
            if (err.status === 401) {
                dispatch(logout())
            }
        } finally {
            setIsLoading(false)
        }
    }

    const onUpdateNik = (e) => {
        setIsEdit(!e)
        setFormData({ ...formData, nik: data.nik })
    }

    const onUpdateSatker = (e) => {
        setIsEditSatker(!e)
        setFormData({ ...formData, nik: data.nik })
    }

    const handleChange = (e) => {
        const { name, value } = e.target
        setFormData({
            ...formData,
            [name]: value
        })

    }

    const handleUpdateNik = async () => {
        setIsUpdateNik(true)
        try {
            const response = await axiosAuth.post('/v1/profile/update-nik', formData, {
                headers: {
                    'Authorization': `Bearer ${dataLogin.token_account}`,
                }
            })
            if (response.data.status_code === 200) {
                swal("Berhasil", "Update NIK Anda berhasil", "success")
                setIsEdit(false)
                getProfileData()
            } else {
                swal('Error', response.data.message, 'error')
            }
        } catch (err) {
            swal('Error', errorHandling(err), 'error')
            if (err.status === 401) {
                dispatch(logout())
            }
        } finally {
            setIsUpdateNik(false)
        }
    }

    // const handleUpdateSatker = async () => {
    //     setIsUpdateSatker(true)
    //     try {
    //         const response = await axiosAuth.put('/v1/profile/update-additional', { ...formDataSatker, kode_satker_utama: formDataSatker.kode_satker_utama.value }, {
    //             headers: {
    //                 'Authorization': `Bearer ${dataLogin.token_account}`,
    //             }
    //         })
    //         if (response.data.status_code === 200) {
    //             swal("Berhasil", "Update Satker Anda berhasil", "success")
    //             setIsEditSatker(false)
    //             getProfileData()
    //         } else {
    //             swal('Error', response.data.message, 'error')
    //         }
    //     } catch (err) {
    //         swal('Error', errorHandling(err), 'error')
    //         if (err.status === 401) {
    //             dispatch(logout())
    //         }
    //     } finally {
    //         setIsUpdateSatker(false)
    //     }
    // }
    const handleUpdateSatker = async () => {
    setIsUpdateSatker(true);
    try {
        const response = await axiosAuth.put('/v1/profile/update-additional', 
            { ...formDataSatker, kode_satker_utama: formDataSatker.kode_satker_utama.value }, 
            {
                headers: {
                    'Authorization': `Bearer ${dataLogin.token_account}`,
                }
            }
        );

        if (response.data.status_code === 200) {
            const newToken = response.data.data.token;

            // 1. Update the main account token in Redux
            dispatch(updateAccountToken(newToken));

            // 2. Trigger the exchange for other apps immediately
            // You can call the logic from useHome or write it inline here:
            await exchangeAfterUpdate(newToken);

            swal("Berhasil", "Update Satker Anda berhasil", "success");
            setIsEditSatker(false);
            getProfileData();
        } else {
            swal('Error', response.data.message, 'error');
        }
    } catch (err) {
        swal('Error', errorHandling(err), 'error');
        if (err.status === 401) {
            dispatch(logout());
        }
    } finally {
        setIsUpdateSatker(false);
    }
};

// Helper inside the component
const exchangeAfterUpdate = async (token) => {
    try {
        const [resTte, resDisp] = await Promise.all([
            axiosTte.post("/v1/token/exchange", {}, { headers: { Authorization: `Bearer ${token}` } }),
            axiosDisposisi.post("/v1/token/exchange", {}, { headers: { Authorization: `Bearer ${token}` } })
        ]);

        dispatch(changeTokenApp({ app: "tte", token: resTte.data.data.token }));
        dispatch(changeTokenApp({ app: "disposisi", token: resDisp.data.data.token }));
    } catch (e) {
        console.log("Token exchange failed after satker update", e);
    }
};
    // const performTokenExchange = async (newTokenAccount) => {
    //     try {
    //         // 1. Exchange for TTE
    //         const resTte = await axiosTte.post("/v1/token/exchange", {}, {
    //             headers: { 'Authorization': `Bearer ${newTokenAccount}` }
    //         });
    //         dispatch(changeTokenApp({ app: "tte", token: resTte.data.data.token }));

    //         // 2. Exchange for Disposisi
    //         const resDisp = await axiosDisposisi.post("/v1/token/exchange", {}, {
    //             headers: { 'Authorization': `Bearer ${newTokenAccount}` }
    //         });
    //         dispatch(changeTokenApp({ app: "disposisi", token: resDisp.data.data.token }));

    //         // Optional: Refresh if needed by your app architecture
    //         window.location.reload(); 
    //     } catch (err) {
    //         console.error("Exchange failed", err);
    //     }
    // };
    const handleProfileSync = async () => {
        try {
            setIsSync(true)
            const response = await axiosAuth.post('/v1/profile/sync', {}, {
                headers: {
                    'Authorization': `Bearer ${dataLogin.token_account}`,
                }
            })
            if (response.data.status_code === 200) {
                swal("Berhasil", "Sinkronisasi berhasil", "success")
                setData(response.data.data)
            } else {
                swal('Error', response.data.message, 'error')
            }
        } catch (err) {
            swal('Error', errorHandling(err), 'error')
            if (err.status === 401) {
                dispatch(logout())
            }
        } finally {
            setIsSync(false)
        }
    }

    const handleChangeFormData = (e) => {
        console.log(e);
        console.log(typeof (e));
        if (e.target) {
            const { name, value } = e.target
            console.log(value);

            setFormDataSatker({ ...formDataSatker, [name]: e.value })
        } else if (Array.isArray(e)) {
            const kepada_id = e.reduce((result, item) => {
                if (!result[item.key]) {
                    result[item.key] = [];
                }
                result[item.key].push({ value: item.value, label: item.label });
                return result;
            }, {});

            setFormData({ ...formDataSatker, kepada_id })
        } else {

            setFormData({ ...formDataSatker, [e.key]: e.value })
        }
    }

    return {
        data,
        isEdit,
        isEditSatker,
        isSync,
        isAdmin,
        formData,
        formDataSatker,
        isLoading,
        isUpdateNik,
        isUpdateSatker,
        navigate,
        allSatker,
        allSatkerOptions,
        setFormDataSatker,
        onUpdateNik,
        handleChange,
        handleUpdateNik,
        handleUpdateSatker,
        handleProfileSync,
        getAllSatker,
        handleChangeFormData,
        mHandleChange,
        selectedValue
    }
}

export default useProfile